export const en = {
  credit_card: 'Credit card',
  request_service : 'Request service'
};

export const ar = {
  credit_card: 'بطاقة ائتمان',
  request_service : 'طلب خدمة'
};
